const selectors = {
  submit: '[data-newsletter-submit]',
  input: '[data-newsletter-input]',
  message: '[data-newsletter-message]',
};

class NewletterSignup extends HTMLElement {
  constructor() {
    super();

    this.submitBtn = document.querySelector(selectors.submit) ?? false;
    this.input = document.querySelector(selectors.input) ?? false;
    this.message = document.querySelector(selectors.message) ?? false;

    this.onSubmit();
    this.checkSignedUp();
  }

  onSubmit() {
    if (!this.submitBtn || !this.input) return;

    this.submitBtn.addEventListener('click', () => {
      const validate = this.validate(this.input.value);

      if (validate) {
        this.showMessage('confirm');
        document.cookie = 'newsletterSignedUp=1';

        setTimeout(() => {
          this.submitBtn.closest('form').submit();
          document.location.reload();
        }, 2000);
      } else {
        this.showMessage('error');
      }
    });
  }

  // eslint-disable-next-line class-methods-use-this
  showMessage(message) {
    const confirmMessage = this.message.dataset.newsletterMessage;
    const errorMessage = 'Your email format is incorrect';

    if (message === 'confirm') {
      this.message.innerHTML = confirmMessage;
    } else {
      this.message.innerHTML = errorMessage;
    }
  }

  checkSignedUp() {
    if (
      document.cookie
        .split(';')
        .some(item => item.includes('newsletterSignedUp=1'))
    ) {
      this.showMessage('confirm');
      this.hideInput();
    }
  }

  hideInput() {
    this.input.classList.add('hidden');
    this.submitBtn.classList.add('hidden');
  }

  // eslint-disable-next-line class-methods-use-this
  validate(email) {
    const regex =
      /^(([^<>()[\]\\.,:\s@"]+(\.[^<>()\\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }
}

customElements.define('newsletter-signup', NewletterSignup);
